import { Component, OnInit, OnDestroy } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ORMLogedInPatient } from 'src/app/models/ormloged-in-patient.model';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationCredentials } from 'src/app/models/authentication-credentials.model';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(300)),
    ]),
  ],
})
export class LoginComponent implements OnInit, OnDestroy {

  loginForm!: FormGroup;
  showDOB = false;      
  showOTP = false;      
  hidebtn = false; 
  userId: number = 0;
  isPhoneInput: boolean = true;
  isPatientId: boolean = false;
  dobFormatError: boolean = false;
  dobFormatMessage = "DOB is required in MMDDYYYY format."
  dobRequiredMessage = "DOB is required"
  otpStatus;
  activeButton: string = ''; 
  unauthorizedError: boolean = false;
  credentialsRequiredError: boolean = false;
  isrememberUsername;
  isrememberPassword;
  userDetail;
  rxSubscription: Subscription = new Subscription();
  phoneEntered = false; 
  alertmessage: boolean = false;
  infomessage;
  return;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public router: Router,
    private logedInUser: ORMLogedInPatient,
    private route: ActivatedRoute,
    protected dialog: MatDialog,
    private authGuard: AuthGuard,
    private encryptDecryptService: EncryptDecryptService,
    protected ipservice: IpAddressService,
    protected NotificationService: NotificationService
  ) {
    this.authService.isAuthenticated = false;
    this.infomessage = "Please enter a valid Patient ID.";
  }

  ngOnInit(): void {
    
    this.queryParamSubscriber();
    this.buildForm(); 
    this.getRememberDetail();
  }

  queryParamSubscriber() {
    combineLatest([this.route.params, this.route.queryParams]).subscribe(
      ([params, queryParams]) => {
        const id = params['id'] || queryParams['id'];
        this.isPatientId = id !== undefined;
        this.isPhoneInput = !this.isPatientId;
        this.userId = id || 0;
      }
    );

    console.log('this.router.url',this.router.url);

    let returnUrl = this.encryptDecryptService.encryptUsingAES256(this.router.url);

    console.log('returnUrl',returnUrl);

    sessionStorage.setItem('returnUrl', returnUrl);
    this.authService.returnUrl = returnUrl;
  }

  buildForm() {
    this.loginForm = this.formBuilder.group({
      username: [
        { value: this.userId !== 0 ? this.userId : '', disabled: this.isPatientId },
        // [Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]   
        [Validators.required]   
      ],
      password: [''],
      otp: [''],
    });

    this.updateUsernameFieldValidator();
  }

  updateUsernameFieldValidator() {
    if (this.isPatientId) {
      this.loginForm.get('username')?.clearValidators();
      this.loginForm.get('username')?.setValue(this.userId);
    } else {
      this.loginForm.get('username')?.setValidators(Validators.required);
    }
    this.loginForm.get('username')?.updateValueAndValidity();
  }


  onNextClick(){
    if(!this.loginForm.get('username')?.invalid){
      this.router.navigateByUrl('/login?id='+ this.loginForm.get('username')?.value)
    }
  }
  // onPhoneInput(event: any) {
  //   let input = event.target.value.replace(/\D/g, '');
  //   if (input.length > 10) {
  //     input = input.slice(0, 10);
  //   }
  //   if (input.length > 6) {
  //     input = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
  //   } else if (input.length > 3) {
  //     input = `(${input.slice(0, 3)}) ${input.slice(3, 6)}`;
  //   } else if (input.length > 0) {
  //     input = `(${input.slice(0, 3)}`;
  //   }
  //   event.target.value = input;  
  //   this.loginForm.controls['username'].setValue(input);  
  //   this.phoneEntered = this.loginForm.get('username')?.valid || false;
  // }
  
  validateNumbers(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Remove non-numeric characters
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  onSubmit() {
    // this.continuebtn(); 
    if (this.loginForm.valid) {
      const formData = this.loginForm.value;
      let payLoad: AuthenticationCredentials = new AuthenticationCredentials();
      payLoad.username = this.userId !== 0 ? this.userId : null;
      payLoad.phone = payLoad.username === null ? this.loginForm.get("username")?.value.replace(/\D/g, '') : null;

      if (this.activeButton === 'dob') {
        let dob = formData.password;
        payLoad.password = this.changeDateFormat(dob);
      } else if (this.activeButton === 'otp') {
        payLoad.password = formData.otp;
      }

      const ApiUrl = this.activeButton === 'dob' ? 'auth/generate-patient-portal-token' : 'auth/verify-patient-otp';
      this.loginApiExecute(ApiUrl, payLoad);
    }
  }

  loginApiExecute(ApiUrl, payLoad) {
    this.rxSubscription = this.authService.authenticateUser(ApiUrl, payLoad).subscribe({
      next: (encryptedData: string | any) => {
        
        if (encryptedData?.status === 200) {
          try {
            const encryptedUserDetails = this.encryptDecryptService.decryptUsingAES256(encryptedData.data);
            sessionStorage.setItem('u.', encryptedData.data);
            this.ipservice.getIPAddress();
            this.userDetail = JSON.parse(encryptedUserDetails);
            this.logedInUser.userId = Number(this.userDetail.user_id);
            this.logedInUser.practiceId = Number(this.userDetail.practice_id);
            this.logedInUser.userFullName = this.userDetail.user_fullname;
            this.practiceInfo(this.logedInUser.practiceId);
            this.NotificationService.showSuccess("login successfully!..");
          } catch (error) {
            this.NotificationService.showError('Error during login processing.');
          }
        } else if (encryptedData?.status === 401) {
          this.unauthorizedError = true;
          // console.log('Authentication error:', encryptedData);
          this.NotificationService.showError(this.infomessage);
        }
        else{
          // console.log('Authentication error:', encryptedData);
          ApiUrl == 'auth/verify-patient-otp' ? this.NotificationService.showError('OTP Invalid!') : this.NotificationService.showError('User Unauthorized!');
          

          // this.showDOB = false;      
          // this.showOTP = false;      
          // this.hidebtn = false; 
          // this.userId = 0;
          // this.isPhoneInput = true;
          // this.isPatientId = false;
          // this.dobFormatError = false;
          // this.dobFormatMessage = "DOB is required in MMDDYYYY format."
          // this.dobRequiredMessage = "DOB is required"
          // this.activeButton = ''; 
          // this.unauthorizedError = false;
          // this.credentialsRequiredError = false;
          // this.phoneEntered = false; 
          // this.buildForm(); 
        }
      },
      error: (error: any) => {
        console.error('Authentication error:', error);
        // Decrypt the error message if possible and log it
        // const errMessage = this.encryptDecryptService.decryptUsingAES256(error?.error?.message || error?.message || 'Unknown error');
        // this.NotificationService.showError(errMessage);
      },
      complete: () => {
        this.router.navigate(['/patient/invoices']);
      }
    });
  }
  

  changeDateFormat(dob: any) {
    if (dob) {
      const reformattedDOB = this.reformatDob(dob);
      this.dobFormatError = reformattedDOB === 'Invalid DOB format';
      return this.dobFormatError ? '' : reformattedDOB;
    }
    return '';
  }

  practiceInfo(practiceId: number) {
    this.authService._practiceInfo(practiceId).subscribe((encryptedData: string | any) => {
      if (encryptedData?.status === 200) {
        try {
          sessionStorage.setItem('p.', encryptedData.data);
          const encryptedPracticeDetail = this.encryptDecryptService.decryptUsingAES256(encryptedData.data);
          const practiceDetails = JSON.parse(encryptedPracticeDetail);
          const userDetails = {
            practiceName: practiceDetails[0]?.practice_name,
            patientName: this.userDetail.user_fullname,
          };
          this.authService.setPracticeAndPatientNames(userDetails);
        } catch (error) {
          console.error('Error parsing practice info:', error);
          this.NotificationService.showError('Error loading practice info.');
        }
      }
    });
  }

  reformatDob(dob: any) {
    if (this.validateDobFormat(dob)) {
      const year = dob.slice(4, 8);
      const month = dob.slice(0, 2);
      const day = dob.slice(2, 4);
      return `${month}-${day}-${year}`;
    } else {
      return 'Invalid DOB format';
    }
  }

  validateDobFormat(dob: any) {
    const pattern = /^(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{4}$/;
    if (!pattern.test(dob)) {
      return false; 
    }

    const year = parseInt(dob.slice(4, 8), 10);
    const month = parseInt(dob.slice(0, 2), 10);
    const day = parseInt(dob.slice(2, 4), 10);

    const dobDate = new Date(year, month - 1, day);
    const currentDate = new Date();

    return dobDate <= currentDate;
  }

  getRememberDetail() {
    const encryptedCredentials = sessionStorage.getItem("c.");
    if (encryptedCredentials) {
      try {
        const decryptedCredentials = JSON.parse(this.encryptDecryptService.decryptUsingAES256(encryptedCredentials));
        const { userName, password, isRemember } = decryptedCredentials;
        this.loginForm.get("username")?.setValue(userName);
        this.loginForm.get("password")?.setValue(password);
        this.loginForm.get("remember")?.setValue(isRemember);
        return isRemember;
      } catch (error) {
        console.error('Error parsing decrypted data:', error);
      }
    } else {
      this.forgetRememberedDetails();
      return false;
    }
  }

  saveRememberDetails(username: any, password: any, isRemember: any) {
    const credentials = JSON.stringify({ userName: username, password: password, isRemember: isRemember });
    sessionStorage.setItem("c.", this.encryptDecryptService.encryptUsingAES256(credentials));
  }

  forgetRememberedDetails() {
    sessionStorage.removeItem("c.");
  }

  shouldUseRememberedDetails() {
    return this.getRememberDetail();
  }

  ngOnDestroy() {
    if (this.rxSubscription) {
      this.rxSubscription.unsubscribe();
    }
  }

  showDOBField() {
    this.hidebtn = true;
    this.activeButton = 'dob';
    this.showDOB = true;
    this.showOTP = false;
    this.unauthorizedError = false;
    this.loginForm.get('password')?.setValidators([Validators.required]);
    this.loginForm.get('otp')?.clearValidators();
    this.loginForm.get('password')?.updateValueAndValidity();
    this.loginForm.get('otp')?.updateValueAndValidity();
  }

  showOTPField() {
    this.activeButton = 'otp';
    this.showOTP = true;
    this.showDOB = false;
    this.hidebtn = true;
    this.unauthorizedError = false;
    this.loginForm.get('otp')?.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
    this.loginForm.get('password')?.clearValidators();
    this.loginForm.get('otp')?.updateValueAndValidity();
    this.loginForm.get('password')?.updateValueAndValidity();
    this.generateOptForLogin();
  }

  generateOptForLogin() {
    let payLoad: any = {
      userId: this.userId !== 0 ? this.userId : null,
    };
    payLoad.userPhone = payLoad.userId === null ? this.loginForm.get("username")?.value.replace(/\D/g, '') : null;

    this.rxSubscription = this.authService.generateOtp(payLoad).subscribe({
      next: (encryptedData: string | any) => {
        const encryptedUserDetails: any = this.encryptDecryptService.decryptUsingAES256(encryptedData.message);
        if (encryptedUserDetails.status === 404) {
          this.alertmessage = true;
          this.infomessage = `${encryptedUserDetails}`;
          this.NotificationService.showError(this.infomessage || 'Unable To Load this Patient!...');
        } else if (encryptedData.status === 200) {
          this.alertmessage = true;
          this.infomessage = `${encryptedUserDetails.replace(/^"|"$/g, '')}`;
          this.NotificationService.showSuccess(this.infomessage || 'OTP sent to the number!...');
        }
      },
      error: (error: any) => {
        this.isPatientId = false;
        this.showDOB = false;
        this.showOTP = false;
        this.infomessage = error.error.message;
        this.NotificationService.showError(this.infomessage || 'Login Failed!...');
      }
    });
  }

  continuebtn() {
    if (this.showOTP === true) {
      // this.onSubmit();
    } else {
      this.showOTP = false;
      // this.onSubmit();
    }
  }

}
